import { palette } from 'app_previous/styles/colors';
import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';

export const TemplateHero = styled.div`
  display: grid;
  position: relative;
  padding: 3rem 2rem 3rem;
  min-height: 582px;
  box-sizing: content-box;
  margin-bottom: 5rem;

  @media screen and (max-width: ${layout.md}) {
    padding: 6rem 2rem 3rem;
  }
`;

export const TemplateTitle = styled.div`
  display: grid;
  z-index: 3;
  position: relative;
  justify-self: center;
  align-self: center;
  column-gap: 3rem;
  grid-template-columns: 358px 1fr;

  @media screen and (max-width: ${layout.md}) {
    grid-template-columns: 1fr;
    grid-row-gap: 3.5rem;
    max-width: 400px;
    margin: 0 auto;
  }
`;

export const TemplateTitleImageLayout = styled.div`
  position: relative;
  padding-top: 92%;
  height: 0;
  width: 100%;
  align-self: center;

  @media screen and (max-width: ${layout.md}) {
    grid-row: 2;
  }
`;

export const TemplateTitleImage = styled.div`
  position: absolute;
  align-self: center;
  z-index: 2;
  display: grid;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 1rem;
  overflow: hidden;
`;

export const TemplateTitleText = styled.div`
  z-index: 2;
  display: grid;
  row-gap: 1rem;
  position: relative;
  max-width: 676px;

  & > h1 {
    justify-self: center;
  }

  @media screen and (max-width: ${layout.md}) {
    grid-row: 1;
  }
`;

export const TemplateTitleBackground = styled.div`
  position: absolute;
  background: rgba(20, 25, 33, 0.9);
  width: 100%;
  height: 100%;
  z-index: 2;
`;

export const TemplateTitleBackgroundImage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
  left: 0;
  top: 0;

  > .gatsby-image-wrapper {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;

export const TemplateTitleMetadata = styled.div`
  display: grid;
  column-gap: 1rem;
  justify-self: start;
  grid-template-columns: max-content 1px max-content;
  grid-template-areas: 'author divider date secondDivider readTime';

  & > p.author {
    grid-area: author;
    text-transform: capitalize;
    max-width: 200px;
    align-self: center;
  }

  & > p.date {
    grid-area: date;
    align-self: center;
  }

  & > p.read-time {
    grid-area: readTime;
    align-self: center;
  }

  &::after {
    content: '';
    grid-area: divider;
    position: relative;
    width: 1px;
    align-self: center;
    height: 0.825rem;
    border-left: solid 1px ${palette.white};
  }

  &::before {
    content: '';
    grid-area: secondDivider;
    position: relative;
    width: 1px;
    align-self: center;
    height: 0.825rem;
    border-left: solid 1px ${palette.white};

    @media screen and (max-width: ${layout.xs}) {
      display: none;
    }
  }

  @media screen and (max-width: ${layout.xs}) {
    grid-template-areas: 'author divider date';

    & > p.read-time {
      display: none;
    }
  }
`;

export const TemplateTitleCategoryChip = styled.p`
  margin: 0;
  color: ${palette.text};
  background-color: ${palette.white};
  padding: 0.5rem 0.5rem 0.35rem 0.5rem;
  border-radius: 4px;
  font-size: 1rem;
  line-height: 1;
  font-weight: 700;
  font-family: 'Walsheim';
  text-transform: uppercase;
  letter-spacing: 1px;
  justify-self: start;
  align-self: center;
`;
